package floris.graphics.models.domain.models.project

import floris.graphics.models.domain.models.*
import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.domain.models.user.User
import floris.graphics.models.domain.models.user.toDto
import floris.graphics.models.domain.models.user.toUser
import floris.graphics.models.dto.requests.project.ProjectDto

data class Project(
    val id: String = "",
    val user: User = User(),
    val title: String = "",
    val subtitle: String = "",
    val content: String = "",
    val previewVideoMediaFile: MediaFile? = null,
    val thumbnailMediaFile: MediaFile? = null,
    val categories: List<Category>? = null,
    val techstacks: List<Techstack>? = null,
    override val createdAt: String = "",
    override val updatedAt: String = "",
    val deletedAt: String? = null
) : DateAble

fun Project.toDto() = ProjectDto(
    id = this.id,
    user = this.user.toDto(),
    title = this.title,
    subtitle = this.subtitle,
    content = content,
    categories = categories?.map { it.toDto() },
    techstacks = techstacks?.map { it.toDto() },
    createdAt = createdAt,
    updatedAt = updatedAt,
    deletedAt = deletedAt
)

fun ProjectDto.toProject() = Project(
    id = id,
    user = user.toUser(),
    title = title,
    subtitle = subtitle,
    content = content,
    previewVideoMediaFile = previewVideoMediaFile?.toMediaFile(),
    thumbnailMediaFile = thumbnailMediaFile?.toMediaFile(),
    categories = categories?.map { it.toCategory() },
    techstacks = techstacks?.map { it.toTechstack() },
    createdAt = createdAt,
    updatedAt = updatedAt,
    deletedAt = deletedAt
)